const AnimateBalance = {
  mounted() {
    const startAmount = parseFloat(this.el.dataset.startAmount);
    const endAmount = parseFloat(this.el.dataset.endAmount);
    const duration = parseInt(this.el.dataset.duration) || 2000;
    
    const startTime = Date.now();
    
    const animate = () => {
      const currentTime = Date.now();
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      const easeOutQuad = (t) => t * (2 - t);
      const easedProgress = easeOutQuad(progress);
      
      const currentAmount = startAmount + (endAmount - startAmount) * easedProgress;
      
      this.el.textContent = `${(currentAmount / 1000000).toFixed(2)}`;
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };
    
    setTimeout(() => {
      requestAnimationFrame(animate);
    }, 500);
  }
};

export default AnimateBalance;
